export default {
  create: {
    method: 'post',
    url: '/route'
  },
  gets: {
    method: 'post',
    url: '/route/list'
  },
  deletes: {
    method: 'delete',
    url: '/route'
  },
  archive: {
    method: 'delete',
    url: '/route/archive'
  },
  get: {
    method: 'get',
    url: '/route/ID'
  },
  getRequest: {
    method: 'get',
    url: '/route/request/ID'
  },
  edit: {
    method: 'put',
    url: '/route/ID'
  }
}
